import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SocketService {
  private socket: Socket = io(environment.socketUrl || undefined, { autoConnect: false });

  constructor(private zone: NgZone) {}

  /**
   * Opens the Socket.IO connection if it is not already connected.
   * @returns void.
   */
  connect() {
    if (!this.socket.connected) this.socket.connect();
  }

  /**
   * Subscribes to a Socket.IO event and re-enters Angular's zone for UI updates.
   * @param eventName Socket event name.
   * @returns Observable that emits event payloads until unsubscribed.
   */
  on<T>(eventName: string) {
    this.connect();
    return new Observable<T>((subscriber) => {
      const handler = (data: T) => this.zone.run(() => subscriber.next(data));
      this.socket.on(eventName, handler);
      return () => this.socket.off(eventName, handler);
    });
  }
}
